import React, { useEffect } from 'react';
import TopSearchTable from "src/pages/ProductListing/TopSearchTable";
import ActiveFilter from "src/pages/ProductListing/ActiveFilter";
import Listing from "src/pages/ProductListing/Listing";
import ProductCompareMiniSlider from 'src/pages/ProductCompare/BottomCompareProduct/ProductCompareMiniSlider';
import $ from "jquery";
import System from "src/helper/system";
import { useProductStore } from 'src/hooks/product';
import { useSearchParams } from "react-router-dom";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';

let c = System.getParams();

export default function ProductListingTabContent(props) {
    const [{ productListWithFacet }, { }, { }, { }] = useProductStore();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        async function fetchHere() {
            let isUniversalSearch = localStorage.getItem("universalSearch");
            if (productListWithFacet?.value &&
                c.ComingFromUniversalSearch &&
                c.ComingFromUniversalSearch === 'yes'
            ) {
                delete c.ComingFromUniversalSearch;
                history.pushState(null, null, '?' + $.param(c));
            }
            //added by Ramya
            if (productListWithFacet?.value &&
                isUniversalSearch) {
                internalSearchEvent();  
            }
        }

        fetchHere()
    }, [productListWithFacet])


    //By Ramya Kannan [Internal search - Adobe script ]
    function internalSearchEvent() {
        let pageCount = searchParams.get("limit") ? searchParams.get("limit") : 20;
        let checkifPagination = Math.round(productListWithFacet?.productCount / pageCount);
        let searchDetails = {
          searchTerm: c.search || "",
          count:productListWithFacet?.productCount,
          pageCount : checkifPagination,
          isPagination: (checkifPagination >= 2) ? 1 : 0
        };
  
        if (Object.keys(searchDetails).length) {
            HelperAnalyticsEvent.internalSearchEvent({ searchDetails });
            localStorage.removeItem("universalSearch");
        }
      }
    return (
        <>
            <div>
                <>
                    <TopSearchTable
                        {...props}
                        openFilterBoxSettings={() => {
                            System.popup('FilterSelectionPopup')
                        }} />
                    <ActiveFilter
                        {...props}
                        openFilterBoxSettings={() => {
                            System.popup('FilterSelectionPopup')
                        }} />
                    <Listing {...props} />
                    <ProductCompareMiniSlider {...props} />
                </>
            </div>
            {/* <MobileView {...props}>
                <ProductListingMobile {...props} />
            </MobileView> */}
        </>
    );
}
